import i18n from 'services/base/i18n';

export default {
  domain: () => i18n.pgettext('Pages|List Issues|View Issue|Malicious Domain', 'Malicious Domain'),
  host:   () => i18n.pgettext('Pages|List Issues|View Issue|Malicious Domain', 'Affected Host'),
  action: () => i18n.pgettext('Pages|List Issues|View Issue|Malicious Domain', 'Enforced Action'),
};
